import packageJson from '../package.json'

export const version: string = packageJson.version
